module.exports = __webpack_public_path__ + "img/1459682595.e8a586d2.jpg";